// extracted by mini-css-extract-plugin
export default {"quizMakerContainer":"QuizMaker_quizMakerContainer__3Ymkw"};